import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { AppLocale, DEFAULT_LOCALE } from './config';
import { I18N_NAMESPACES, resources } from './resources';
import { resolveAnonymousLocale } from './localeResolver';

void i18n.use(initReactI18next).init({
  resources,
  lng: resolveAnonymousLocale().locale,
  fallbackLng: DEFAULT_LOCALE,
  defaultNS: 'common',
  ns: I18N_NAMESPACES,
  returnEmptyString: false,
  parseMissingKeyHandler: (_key, defaultValue) =>
    typeof defaultValue === 'string' && defaultValue.trim()
      ? defaultValue
      : 'Texto indisponível',
  saveMissing: process.env.NODE_ENV !== 'production',
  missingKeyHandler: (lngs, namespace, key) => {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('[i18n] Missing translation', { locales: lngs, namespace, key });
    }
  },
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

export const changeAppLocale = (locale: AppLocale): Promise<void> =>
  i18n.changeLanguage(locale).then(() => undefined);

export { i18n };
export * from './config';
export * from './localeResolver';
